const Parameter = () =>
  import(
    /* webpackChunkName: "system-operation-parameter" */ '@/pages/system/operation/parameter.vue'
  )

export default {
  path: 'parameter',
  meta: {
    label: 'parameter',
    auth: 'parameter'
  },
  component: {
    name: 'Parameter',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'OperationParameterReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Parameter
    }
  ]
}
